interface IClicableItemProps {
  onClick: (() => void) | undefined
  children: React.ReactNode
}
export default function ClicableItem({ children, onClick }: IClicableItemProps) {
  return (
    <div onClick={onClick} style={{ cursor: 'pointer' }}>
      {children}
    </div>
  )
}
